module.exports = __webpack_public_path__ + "media/images/deactive-a8db6e40d5edb7756f163c2d597eea2e.svg";